import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivityService } from 'ng-metro4';
import { BehaviorSubject, Observable, Observer, Subject } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { environment } from '../../environments/environment';
import { confirmation } from '../mocks/confirm-response-for-request';
import { ActionResponse } from '../models/admin/role';
import { ColumnModel } from '../models/column-model';
import { CreateTraceModel } from '../models/create-trace-model';
import { FilterEntity } from '../models/filter/filter-entity';
import { FindEntity } from '../models/filter/find-entity';
import { GenericsService } from './generics.service';
import { TokenStorageService } from './token-storage.service';
import {BASE_URL, BASE_URL_AUTH, BASE_URL_GESCOM_V1, TYPE_TERMINAL} from '../app.constants';
import { TranslateService } from '@ngx-translate/core';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public actions: Observable<ActionResponse[]>;
  public actions2: Observable<ActionResponse[]>;
  private localActions: ActionResponse[] = [];
  public authUrl = BASE_URL_AUTH + '/auth';
  public contents: any[];
  public matcontents: any[];

  public availableColumns: ColumnModel[];
  public userColumns: ColumnModel[];
  public columns: ColumnModel[];

  public itemsPerPage: number;
  public currentPage: number;
  public totalItems: number;
  public totalPages: number;

  public tiersSelect;
  public filter: FindEntity;

  /* Nous allons charger dans ces variables les ids de colonnes a ajouter
  * ou a soustraire a l'affichage */
  public addColumns = [];
  public removeColumns = [];
  // Declaration des subjects pour dispatcher les resultats du colonnage
  private availableColumnSubject = new Subject<any>();
  private userColumnSubject = new Subject<any>();
  private softColumns = new Subject<any>();
  private documentSubject = new Subject<any>();
  public codejSelect: any;
  totalRGMontant: any;
  totalImpute: any;
  solde: number;
  contentsLot: any;
  matcontentsLot: any;
  addColumnsLot: any[];
  removeColumnsLot: any[];
  userColumnsLot: any;
  columnsLot: any[];
  softColumnsLot = new Subject<any>();
  userColumnSubjectLot = new Subject<any>();
  availableColumnsLot: ColumnModel[];
  availableColumnSubjectLot = new Subject<any>();
  totalNonImputer: any;
  totalRGMontantNonImputer: number;

  private matcontentsSubject = new BehaviorSubject<any[]>([]);
  matcontents$ = this.matcontentsSubject.asObservable();
  idWindow: any;
  action2: Observable<any>;

  constructor(
    private http: HttpClient,
    private tokenStorage: TokenStorageService,
    public genericsService: GenericsService,
    private activityService: ActivityService,
    private translate: TranslateService,
  ) {
  }

  onResetContent() {
    this.matcontents = [];
    this.contents = [];
  }

  /**
   * @param credentials
   * connecter un utilisateur
   */
  login(credentials): Observable<any> {
    return this.http.post(`${this.authUrl}/users/sign-in`, {
      username: credentials.username,
      password: credentials.password,
      loginMode: credentials.loginMode,
      typeTerminal: TYPE_TERMINAL
    }, httpOptions);
  }

  /**
   * @param user
   * Sauvegarger un utilisateur depuis le client web
   */
  register(user): Observable<any> {
    return this.http.post(`${this.authUrl}/users/sign-up`, user, httpOptions);
  }

  updateUser(user): Observable<any> {
    return this.http.put(`${this.authUrl}/users/update`, user, httpOptions);
  }

  updatePreference(updatePreferenceUserDTO: any): Observable<any> {
    return this.http.put(`${this.authUrl}/users/preference`, updatePreferenceUserDTO, httpOptions);
  }

  /*   getUser(user): Observable<any> {
      return this.http.get(`${this.authUrl}/users/update`, user, httpOptions);
    }
   */
  public getUser(userId): Observable<any> {
    return this.http.get(`${this.authUrl}/users/details/${userId}`);
  }

  public getUserDashboard(userId): Observable<any> {
    return this.http.get(`${this.authUrl}/users/dashboard/${userId}?navigation=1`);
  }

  public getSiteDashboard(siteId): Observable<any> {
    return this.http.get(`${this.authUrl}/sites/dashboard/${siteId}`);
  }

  reload() {
    this.contents = [];
    this.matcontents = [];
  }

  /**
   * Lecture de toutes les entites de la base de donnees, ceci est appeles dans
   * tout les components de listing de donnees sans traitement particulieres
   * param url
   * param filter
   */
  onGetEntityByFilter(url, filter: FindEntity, ifNotLoadData?: boolean, callLoading?: boolean) {
    filter.idSite = this.tokenStorage.getCurrentSite();
    this.onGetUserColumn(this.tokenStorage.getUser().id, filter.idWindow);
    if (ifNotLoadData) {
      this.contents = undefined;
      this.itemsPerPage = environment.defaultListSize;
      this.currentPage = 0;
      this.totalItems = 0;
      this.totalPages = 0;
      this.matcontents = undefined;
    } else {
      let activity;
      if (callLoading) {
        activity = this.tokenStorage.getLangue() === 'FR' ? this.activityService.open({
          style: 'color',
          text: `<div class="mt-2 display1 fg-darkBlue">Chargement ...</div>`,
          type: 'cycle',
          overlayColor: '#a7a0a0',
        }) : this.activityService.open({
          style: 'color',
          text: `<div class="mt-2 display1 fg-darkBlue">Loading ...</div>`,
          type: 'cycle',
          overlayColor: '#a7a0a0',
        });
      }
      this.contents = undefined;
      this.itemsPerPage = environment.defaultListSize;
      this.currentPage = 0;
      this.totalItems = 0;
      this.totalPages = 0;
      this.addColumns = [];
      this.removeColumns = [];
      this.matcontents = [];
      this.genericsService.postResource(url, filter).then((result: any) => {
        if (result.code === 200) {
          this.activityService.close(activity);
          this.contents = result.data.content;
          this.itemsPerPage = result.data.pageable.pageSize;
          this.currentPage = result.data.number;
          this.totalItems = result.data.totalElements;
          this.totalPages = result.data.totalPages;

          if (this.userColumns) {
            this.matcontents = [];
            this.contents.forEach((element) => {
              this.columns = [];
              const line = [];
              Object.entries(element).forEach(([key, value]) => {
                line.push({
                  id: key,
                  // tslint:disable-next-line:triple-equals
                  name: value == '1752-12-31T23:00:00.000+0000' ? null : value,
                  column: this.userColumns.filter((test) => (test.nameColumn === '[' + key + ']'
                    || test.nameColumn === key || test.value === key))[0],
                });
                if (this.userColumns.filter((test) => (test.nameColumn === '[' + key + ']'
                  || test.nameColumn === key || test.value === key)).length > 0) {
                  this.columns.push(this.userColumns.filter((test) => (test.nameColumn === '[' + key + ']'
                    || test.nameColumn === key || test.value === key))[0]);
                  /**
                   * trier les colone de l'entete du tableau suivante un numéro d'ordre croissant
                   */
                  // this.columns = this.columns.sort((a, b) => a.numOrder - b.numOrder);
                }
              });
              this.matcontents.push(line);
            });
            this.setMatcontents(this.matcontents);
            /**
             * trier les lignes du tableau suivante un numéro d'ordre croissant
             */
            // this.matcontents.forEach(row => {
            //   row.sort((a, b) => {
            //     if (a.column && b.column) {
            //       return a.column.numOrder - b.column.numOrder;
            //     }
            //     return [];
            //   });
            // });
            if (this.contents.length === 0) {
              this.columns = this.userColumns;
              /**
               * trier les colone a afficher suivante un numéro d'ordre croissant
               */
              // this.columns = this.columns.sort((a, b) => a.numOrder - b.numOrder);
            }
            this.softColumns.next({ columns: this.columns });
          }
          this.totalRGMontant = 0;
          this.totalImpute = 0;
          this.totalRGMontantNonImputer = 0;
          if (filter.idWindow === 54 && this.matcontents && this.matcontents.length > 0) {
            const matcontents = this.matcontents;
            if (matcontents) {
              this.totalRGMontant = this.calculTotalRGMontant(matcontents);
              this.totalImpute = this.calculTotalImpute(matcontents);
              this.solde = this.totalRGMontant - this.totalImpute;
              const totalNonImpute = this.calculTotalRGMontantNonImputer(matcontents);
              this.totalRGMontantNonImputer = this.totalRGMontant - totalNonImpute;
            }
          }
        } else {
          this.activityService.close(activity);
          this.contents = [];
          Swal.fire(confirmation(result.message,
            'center', 'error', true, 10000));
        }
        this.documentSubject.next({ doc: this.contents });
        window.scroll(0, 0);
        this.activityService.close(activity);
      }, (error) => {
        this.activityService.close(activity);
        activity = null;
        this.contents = [];
      });
    }
  }

  setMatcontents(data: any[]): void {
    this.matcontentsSubject.next(data);
  }

  calculTotalRGMontant(matcontents: any) {
    const montantRG = matcontents
      .map((item) => item[4].name)
      .reduce((acc, curr) => acc + curr, 0);
    return montantRG;
  }

  calculTotalRGMontantNonImputer(matcontents: any) {
    const montantNonImputer = matcontents
      .map((item) => (item[22] && item[22].name) ? item[22].name : 0)
      .reduce((acc, curr) => acc + curr, 0);
    return montantNonImputer;
  }

  calculTotalImputeV1(matcontents: any) {
    const montantImpute = matcontents
      .filter((item) => item[7].name === 1)
      .map((item) => item[4].name)
      .reduce((acc, curr) => acc + curr, 0);
    return montantImpute;
  }
  calculTotalImpute(matcontents: any) {
    const montantImpute = matcontents
      .map((item) => item[17].name)
      .reduce((acc, curr) => acc + curr, 0);
    return montantImpute;
  }
  onReInitColonnage(idUser, idWindow) {
    this.genericsService.getResource(`/system/column/init/${idUser}/${idWindow}`).then((result: any) => {
      this.onGetAvailableColumn(idWindow);
      this.onGetUserColumn(idUser, idWindow);
    }, (error) => {
      this.userColumns = [];
    });
  }

  // retrieve colonnes disponibles
  onGetAvailableColumn(idWindow) {
    this.genericsService.postResource(`/system/column/available/${this.tokenStorage.getUser().id}/${idWindow}`, {}).then((result: any) => {
      if (result.code === 200) {
        this.availableColumns = result.data;
        this.availableColumnSubject.next({ aColumns: this.availableColumns });
      } else {
        this.availableColumns = [];
      }
    }, (error) => {
      this.availableColumns = [];
    });
  }

  // retrieve colonnes d'un utilisateur
  onGetUserColumn(idUser, idWindow) {
    this.idWindow = idWindow;
    this.genericsService.postResource(`/system/column/find/${idUser}/${idWindow}`, {}).then((result: any) => {
      if (result.code === 200) {

        this.userColumns = result.data.filter((elt) => elt.printable === true)
          .sort((a, b) => a.numOrder - b.numOrder);
        this.userColumnSubject.next({ uColumns: this.userColumns });
      } else {
        this.userColumns = [];
      }
    }, (error) => {
      this.userColumns = [];
    });
  }

  // vider les colonnes disponibles
  clearAC() {
    this.availableColumnSubject.next();
  }

  // vider les colonnes utilisateurs si neccessaire
  clearUC() {
    this.availableColumnSubject.next();
  }

  // vider les colonnes utilisateurs si neccessaire
  clearDocument() {
    this.documentSubject.next();
  }
  // methodes de souscriptions aux differents colonnes
  getAC() {
    return this.availableColumnSubject.asObservable();
  }

  getUC() {
    return this.userColumnSubject.asObservable();
  }
  getColumn() {
    return this.softColumns.asObservable();
  }

  getDocument() {
    return this.documentSubject.asObservable();
  }

  onGetTiers(type, disposeLabel) {
    let filter;
    if (type !== '') {
      filter = new FilterEntity('CT_Type', 'ENTIER', null, '=', type, null);
    }
    this.filter = new FindEntity('F_COMPTET', filter ? [filter] : null, this.tokenStorage.getCurrentSite(), 20, 0, 200);
    this.genericsService.postResource(environment.entityUrls.gescom, this.filter).then((result: any) => {
      this.tiersSelect = {};
      if (result.code === 200) {
        result.data.content.forEach((item) => this.tiersSelect[item.CT_NumPayeur] = item.CT_Intitule + ' ' + item.CT_Ville);
      }
    }, (error) => {
    });
  }

  onGetSelectCodeJournaux() {
    this.filter = new FindEntity('F_JOURNAUX', null, this.tokenStorage.getCurrentSite(), 90, 0, 200);
    this.genericsService.postResource(environment.entityUrls.gescom, this.filter).then((result: any) => {
      this.codejSelect = {};
      if (result.code === 200) {
        result.data.content.forEach((item) => this.codejSelect[item.JO_Num] = item.JO_Intitule);
      }
    }, (error) => {

    });
  }

  onSaveTraceAction(data: CreateTraceModel) {
    data.codeIsoLang = localStorage.getItem('lang');
    data.siteId = this.tokenStorage.getCurrentSite();
    // this.genericsService.postResource(`/system/save/snitch`, data).then((resp: any) => {
    // });
  }

  public listMyActions(roleId: number, fenetreId) {
    return this.http.get(`${BASE_URL_GESCOM_V1}/system/habilitation/${roleId}/fenetre/${fenetreId}/action/liste`).toPromise();
  }

  public returnListAction(idFenetre: number): Observable<any> {
    const acts = [];
    let i = 0;
    // const rolesToCheck = this.tokenStorage.getUser().habilitations.filter(item => item.id !== 2);
    const idHabilitation = this.tokenStorage.getHabilitation();
    // console.log(idHabilitation);
    if (idHabilitation) {
      // rolesToCheck.forEach(item => {
      // tslint:disable-next-line:radix

      this.listMyActions(parseInt(idHabilitation), idFenetre).then((response: any) => {
        if (response.code === 200 && response.data.length > 0) {
          response.data.forEach((action) => {
            i++;
            acts.push(action);
          });
        }
      }).catch((reason) => { });
      this.localActions = acts;
      // });

    }
    this.actions = new Observable((observer: Observer<ActionResponse[]>) => {
      observer.next(acts);
    });

    return this.actions;
  }

  public returnListAction2(idFenetre: number): Observable<any> {
    const acts = [];
    let i = 0;
    // const rolesToCheck = this.tokenStorage.getUser().habilitations.filter(item => item.id !== 2);
    const idHabilitation = this.tokenStorage.getHabilitation();
    if (idHabilitation) {
      // rolesToCheck.forEach(item => {
      // tslint:disable-next-line:radix

      this.listMyActions(parseInt(idHabilitation), idFenetre).then((response: any) => {
        if (response.code === 200 && response.data.length > 0) {
          response.data.forEach((action) => {
            i++;
            acts.push(action);
          });
          if (i == response.data.length) {
            this.tokenStorage.saveActions(acts);
          }
        }
      }).catch((reason) => { });

    }
    this.actions2 = new Observable((observer: Observer<ActionResponse[]>) => {
      observer.next(acts);
    });

    return this.actions2;
  }

  isActif(id: string): boolean {
    if (this.tokenStorage.getUser()) {
      const btns = this.localActions.length > 0 ? this.localActions.filter((item) => item.idObjet === id) : [];
      const validation = btns.some((btnItem) => btnItem.conditionActif === 'true');
      const valueRoleUserSociete = this.tokenStorage.getRoleUserSociete()?.valeur;
      if (valueRoleUserSociete === '1') {
        return (this.tokenStorage.getUser().habilitations.some((item) => (item.code === 'ADMINISTRATEUR' || item.code === 'ADMIN_SOCIETE')) || validation);
      }
      return (this.tokenStorage.getUser().habilitations.some((item) => (item.code === 'ADMINISTRATEUR')) || validation);
    }
  }

  isVisible(id: string): boolean {
    if (this.tokenStorage.getUser()) {
      const btns = this.localActions.length > 0 ? this.localActions.filter((item) => item.idObjet === id) : [];
      // console.log(btns);
      const validation = btns.some((btnItem) => btnItem.conditionVisible === 'true');
      // console.log(validation);
      // console.log(this.tokenStorage.getUser().habilitations);
      const valueRoleUserSociete = this.tokenStorage.getRoleUserSociete()?.valeur;
      if (valueRoleUserSociete === '1') {
        return (this.tokenStorage.getUser().habilitations.some((item) => (item.code === 'ADMINISTRATEUR' || item.code === 'ADMIN_SOCIETE')) || validation);
      }
      return (this.tokenStorage.getUser().habilitations.some((item) => (item.code === 'ADMINISTRATEUR')) || validation);
    }
  }

  isEditable(id: string): boolean {
    if (this.tokenStorage.getUser()) {
      const btns = this.localActions.length > 0 ? this.localActions.filter((item) => item.idObjet === id) : [];
      const validation = btns.some((btnItem) => btnItem.conditionEditable === 'true');
      const valueRoleUserSociete = this.tokenStorage.getRoleUserSociete()?.valeur;
      if (valueRoleUserSociete === '1') {
        return (this.tokenStorage.getUser().habilitations.some((item) => (item.code === 'ADMINISTRATEUR' || item.code === 'ADMIN_SOCIETE')) || validation);
      }
      return (this.tokenStorage.getUser().habilitations.some((item) => (item.code === 'ADMINISTRATEUR')) || validation);
    }
  }

  isVisibleLocal(id: string): boolean {
    if (this.tokenStorage.getUser()) {
      // console.log(this.tokenStorage.getUser().habilitations);
      const localActions = this.tokenStorage.getActions()
      const btns = (localActions && localActions.length > 0) ? localActions.filter((item) => item.idObjet === id) : [];
      const validation = btns.some((btnItem) => btnItem.conditionVisible === 'true');
      const valueRoleUserSociete = this.tokenStorage.getRoleUserSociete()?.valeur;
      // console.log(valueRoleUserSociete);
      if (valueRoleUserSociete === '1') {
        return (this.tokenStorage.getUser().habilitations.some((item) => (item.code === 'ADMINISTRATEUR' ||
          item.code === 'ADMIN_SOCIETE')) || validation);
      }
      return (this.tokenStorage.getUser().habilitations.some((item) => (item.code === 'ADMINISTRATEUR')) || validation);
    }
  }
  onGetEntityByFilterLot(url, filter: FindEntity, ifNotLoadData?: boolean) {
    filter.idSite = this.tokenStorage.getCurrentSite();
    this.onGetUserColumn(this.tokenStorage.getUser().id, filter.idWindow);
    if (ifNotLoadData) {
      this.contentsLot = undefined;
      this.itemsPerPage = environment.defaultListSize;
      this.currentPage = 0;
      this.totalItems = 0;
      this.totalPages = 0;
      this.matcontentsLot = undefined;
    } else {
      // let activity = this.activityService.open({
      //   style: 'color',
      //   text: `<div class="mt-2 display1 fg-darkBlue">${this.translate.instant('LOADING')}</div>`,
      //   type: 'cycle',
      //   overlayColor: '#a7a0a0',
      // });
      this.contentsLot = undefined;
      this.addColumnsLot = [];
      this.removeColumnsLot = [];
      // this.matcontentsLot = [];
      this.genericsService.postResource(url, filter).then((result: any) => {
        if (result.code === 200) {
          // this.activityService.close(activity);
          this.contentsLot = result.data.content;
          this.itemsPerPage = result.data.pageable.pageSize;
          this.currentPage = result.data.number;
          this.totalItems = result.data.totalElements;
          this.totalPages = result.data.totalPages;
          this.matcontentsLot = [];
          if (this.userColumnsLot) {
            this.contentsLot.forEach((element) => {
              this.columnsLot = [];
              const line = [];
              Object.entries(element).forEach(([key, value]) => {
                line.push({
                  id: key,
                  // tslint:disable-next-line:triple-equals
                  name: value == '1752-12-31T23:00:00.000+0000' ? null : value,
                  column: this.userColumnsLot.filter((test) => (test.nameColumn === '[' + key + ']'
                    || test.nameColumn === key || test.value === key))[0],
                });
                if (this.userColumnsLot.filter((test) => (test.nameColumn === '[' + key + ']'
                  || test.nameColumn === key || test.value === key)).length > 0) {
                  this.columnsLot.push(this.userColumnsLot.filter((test) => (test.nameColumn === '[' + key + ']'
                    || test.nameColumn === key || test.value === key))[0]);
                }
              });
              this.matcontentsLot.push(line);
            });
            if (this.contentsLot.length === 0) {
              this.columnsLot = this.userColumnsLot;
            }
            this.softColumnsLot.next({ columnsLot: this.columnsLot });
          }
          if (filter.idWindow === 54 && this.matcontentsLot && this.matcontentsLot.length > 0) {
            const matcontentsLot = this.matcontentsLot;
          }
        } else {
          this.contentsLot = [];
          Swal.fire(confirmation(result.message,
            'center', 'error', true, 10000));
        }
        this.documentSubject.next({ doc: this.contentsLot });
        window.scroll(0, 0);
        // this.activityService.close(activity);
      }, (error) => {
        // this.activityService.close(activity);
        // activity = null;
        this.contentsLot = [];
      });
    }
  }

  // retrieve colonnes d'un utilisateur
  onGetUserColumnLot(idUser, idWindow) {
    this.genericsService.postResource(`/system/column/find/${idUser}/${idWindow}`, {}).then((result: any) => {
      if (result.code === 200) {
        this.userColumnsLot = result.data.filter((elt) => elt.printable === true);
        this.userColumnSubjectLot.next({ uColumnsLot: this.userColumnsLot });
      } else {
        this.userColumnsLot = [];
      }
    }, (error) => {
      this.userColumnsLot = [];
    });
  }

  // retrieve colonnes disponibles
  onGetAvailableColumnLot(idWindow) {
    this.genericsService.postResource(`/system/column/available/${this.tokenStorage.getUser().id}/${idWindow}`, {}).then((result: any) => {
      if (result.code === 200) {
        this.availableColumnsLot = result.data;
        this.availableColumnSubjectLot.next({ aColumnsLot: this.availableColumnsLot });
      } else {
        this.availableColumnsLot = [];
      }
    }, (error) => {
      this.availableColumnsLot = [];
    });
  }

  // vider les colonnes disponibles
  clearACLot() {
    this.availableColumnSubjectLot.next();
  }
  // vider les colonnes utilisateurs si neccessaire
  clearUCLot() {
    this.availableColumnSubjectLot.next();
  }
  /*  // vider les colonnes utilisateurs si neccessaire
   clearDocumentLot() {
     this.documentSubjectLot.next();
   } */
  // methodes de souscriptions aux differents colonnes
  getACLot() {
    return this.availableColumnSubjectLot.asObservable();
  }
  getUCLot() {
    return this.userColumnSubjectLot.asObservable();
  }
  getColumnLot() {
    return this.softColumnsLot.asObservable();
  }
  /*
      getDocumentLot() {
        return this.documentSubjectLot.asObservable();
      } */
}
